import { render } from "./b2cUsers.vue?vue&type=template&id=64f97d08&scoped=true"
import script from "./b2cUsers.vue?vue&type=script&lang=js"
export * from "./b2cUsers.vue?vue&type=script&lang=js"

import "./b2cUsers.vue?vue&type=style&index=0&id=64f97d08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f97d08"]])

export default __exports__